import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { BankTransferTemplateDTO } from "../../types/BankTransferTemplateDTO";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  templates: BankTransferTemplateDTO[];
  value: BankTransferTemplateDTO | null;
  onChange: (template: BankTransferTemplateDTO | null) => void;
};

export default function BankTransferTemplateSelect({
  templates,
  value,
  onChange,
}: Props) {
  const { t } = useAppTranslation("common");

  return (
    <FormControl fullWidth>
      <InputLabel id="bank-template-label">
        {t("Szablon przelewu")}
      </InputLabel>

      <Select
        labelId="bank-template-label"
        label={t("Szablon przelewu")}
        value={value?.systemId ?? ""}
        onChange={(e) => {
          const template = templates.find(
            (t) => t.systemId === e.target.value
          );
          onChange(template ?? null);
        }}
      >
        {templates.map((t) => (
          <MenuItem key={t.systemId} value={t.systemId}>
            {t.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
